import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { ModelForm } from '../components';

export default function Dailyrate({ formMode }) {
	const { id } = useParams();
	const [openedAt] = useState(() => new Date().toISOString());
	const defaultValues = id ? {} : { effectiveDate: openedAt };
	return (
		<Grid container>
			<ModelForm
				recordId={id}
				formName={'createDailyrateForm'}
				initialMode={formMode}
				defaultValues={defaultValues}
			/>
		</Grid>
	);
}
